export const chartClasses = "d-flex justify-content-center flex-column text-center";